export default __webpack_public_path__ + "static/media/navbar-logs-dark.8cb37187.svg";